import { createMuiTheme } from "@material-ui/core/styles";
import { blue, blueGrey } from "@material-ui/core/colors";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {}
  interface PaletteOptions {}
}

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: blue[600],
    },
    secondary: {
      main: blueGrey[500],
    },
  },
  typography: {
    h1: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h2: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h3: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h4: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h5: {
      fontWeight: 400,
      color: "#1e2022",
    },
    h6: {
      fontWeight: 400,
      color: "#1e2022",
    },
  },
});



// WEBPACK FOOTER //
// ./src/utils/Theme.ts